import i18n from '../../../i18n';
import isEmpty from 'lodash/isEmpty';
import {isValidPhoneNumber} from "libphonenumber-js";
import isEmail from "validator/lib/isEmail";

export const validate = values => {
    let errors = {};

    firstName(values, errors);
    lastName(values, errors);
    phoneNumber(values, errors);
    clientEmail(values, errors);

    return errors;
};

const firstName = (values, errors) => {
    if (isEmpty(values.firstName)) {
        return errors.firstName = i18n.t('booking.validation_firstname');
    }
};

const lastName = (values, errors) => {
    if (isEmpty(values.lastName)) {
        return errors.lastName = i18n.t('booking.validation_lastname');
    }
};

const clientEmail = (values, errors) => {
    if (!isEmpty(values.clientEmail) && !isEmail(values.clientEmail)) {
        return errors.clientEmail = i18n.t('account.validation_email_not_valid');
    }
};

const phoneNumber = (values, errors) => {
    const value = values.phoneNumber;

    if(!isEmpty(value) && !isValidPhoneNumber(value)) {
        errors.phoneNumber = i18n.t('booking.validation_phone');
    }
    if(isEmpty(value)){
        return errors.phoneNumber = i18n.t('account.validation_phone');
    }
};
